import { useCallback, useMemo } from 'react';
import { isGroupHeader } from '../helpers';
import { areGroupedItems, flattenGroupItemsToDownshift, flattenGroupItemsToNonDownshift, getStartingIndices } from '../helpers/groupedItems';
export default (_ref => {
  let {
    maybeGroupedItems
  } = _ref;
  const isGrouped = areGroupedItems(maybeGroupedItems);
  const flatItems = useMemo(() => flattenGroupItemsToDownshift(maybeGroupedItems), [maybeGroupedItems]);
  const {
    flatItemsWithGroupHeaders,
    mapDownshiftItemToItemWithGroupInfo
  } = useMemo(() => {
    if (!areGroupedItems(maybeGroupedItems)) {
      return {
        startingIndices: new Map(),
        indexGetter: undefined
      };
    }
    const startingIndices = getStartingIndices(maybeGroupedItems);
    const flatItemsWithGroupHeaders = flattenGroupItemsToNonDownshift(maybeGroupedItems, startingIndices);
    const flatItemsWithGroupInfo = flatItemsWithGroupHeaders.filter(item => !isGroupHeader(item)); // The filter removes the GroupHeaders but they're still included in the type

    const mapDownshiftItemToItemWithGroupInfo = flatItems.reduce((map, curr, i) => {
      map.set(curr, flatItemsWithGroupInfo[i]);
      return map;
    }, new Map());
    return {
      flatItemsWithGroupHeaders,
      mapDownshiftItemToItemWithGroupInfo
    };
  }, [flatItems, maybeGroupedItems]);

  /**
   * Gets the index for downshift
   * We need to determine this manually so we skip over group headers
   */
  const indexGetter = useMemo(() => isGrouped ? item => {
    var _mapDownshiftItemToIt;
    return mapDownshiftItemToItemWithGroupInfo === null || mapDownshiftItemToItemWithGroupInfo === void 0 ? void 0 : (_mapDownshiftItemToIt = mapDownshiftItemToItemWithGroupInfo.get(item)) === null || _mapDownshiftItemToIt === void 0 ? void 0 : _mapDownshiftItemToIt.index;
  } : null, [isGrouped, mapDownshiftItemToItemWithGroupInfo]);

  /** Adds group headers for provided items
   * @param itemsToShow The (potentially) filtered list of items to show
   */
  const getMenuItems = useCallback(itemsToShow => {
    if (!isGrouped) {
      return itemsToShow;
    }
    const filteredGroupedMenuItems = [];
    const flattenItemsMap = new Map();
    flatItemsWithGroupHeaders === null || flatItemsWithGroupHeaders === void 0 ? void 0 : flatItemsWithGroupHeaders.forEach(item => {
      if (item.isGroupHeader) {
        flattenItemsMap.set(item.groupKey, item);
      }
    });
    const filteredGroupedMenuItemsSet = new Set();
    itemsToShow.forEach((filteredItem, i) => {
      const filteredGroupedItem = mapDownshiftItemToItemWithGroupInfo === null || mapDownshiftItemToItemWithGroupInfo === void 0 ? void 0 : mapDownshiftItemToItemWithGroupInfo.get(filteredItem);
      if (!filteredGroupedItem) {
        return;
      }
      const groupHeader = flattenItemsMap.get(filteredGroupedItem.groupKey);
      if (groupHeader && !filteredGroupedMenuItemsSet.has(groupHeader)) {
        filteredGroupedMenuItemsSet.add(groupHeader);
        filteredGroupedMenuItems.push(groupHeader);
      }
      filteredGroupedItem.index = i;
      filteredGroupedMenuItems.push(filteredItem);
    });
    return filteredGroupedMenuItems;
  }, [flatItemsWithGroupHeaders, isGrouped, mapDownshiftItemToItemWithGroupInfo]);
  return {
    flatItems,
    indexGetter,
    getMenuItems
  };
});
//# sourceMappingURL=useGroupedItems.js.map